import { useInsert_Block_List_Item_OneMutation } from '@geerd-nx/shareable-graphql';

export function useCreateBlockListItem() {
  const [mutate] = useInsert_Block_List_Item_OneMutation({
    update: (cache, { data }) => {
      cache.modify({
        fields: {
          block_list_item(existing = []) {
            return [
              {
                ...data?.insert_block_list_item_one,
                __typename: 'block_list_item',
              },
              ...existing,
            ];
          },
          block_list_item_aggregate(oldData) {
            return {
              aggregate: {
                count: oldData.aggregate.count + 1,
              },
            };
          },
        },
      });
    },
  });
  return mutate;
}
